<template>
	<div>
		<!-- 闲置买卖 -->
		<div class="leaveUnused">
			<div class="textCenter f28 pt25">
				闲置变现 就在云当铺
			</div>
			<div class="line"></div>
			<div class="listLuCon pt25">
				<!-- 专业检测 -->
				<div class="listLu">
					<div class="title ">
						<img class="messageImg" src="../../static/shop/zyjcRed.png" />
						<img class="messageImgActive" src="../../static/shop/zyjcWhite.png" />
					</div>
					<div class="f16 mt15 mb15" v-if="indexPubList[0]">{{indexPubList[0].indexTitle}}</div>
					<div class="f12 fontColor8F textCenter" v-if="indexPubList[0]">{{indexPubList[0].indexDec}}</div>
				</div>
				<!-- 严格把控 -->
				<div class="listLu">
					<div class="title ">
						<img class="messageImg" src="../../static/shop/ygbkRed.png" />
						<img class="messageImgActive" src="../../static/shop/ygbkWhite.png" />
					</div>
					<div class="f16 mt15 mb15" v-if="indexPubList[1]">{{indexPubList[1].indexTitle}}</div>
					<div class="f12 fontColor8F textCenter" v-if="indexPubList[1]">{{indexPubList[1].indexDec}}</div>
				</div>
				<!-- 专业服务 -->
				<div class="listLu">
					<div class="title ">
						<img class="messageImg" src="../../static/shop/zyfwRed.png" />
						<img class="messageImgActive" src="../../static/shop/zyfwWhite.png" />
					</div>
					<div class="f16 mt15 mb15" v-if="indexPubList[2]">{{indexPubList[2].indexTitle}}</div>
					<div class="f12 fontColor8F textCenter" v-if="indexPubList[2]">{{indexPubList[2].indexDec}}</div>
				</div>
				<!-- 安心选购 -->
				<div class="listLu">
					<div class="title ">
						<img class="messageImg" src="../../static/shop/axxgRed.png" />
						<img class="messageImgActive" src="../../static/shop/axxgWhite.png" />
					</div>
					<div class="f16 mt15 mb15" v-if="indexPubList[3]">{{indexPubList[3].indexTitle}}</div>
					<div class="f12 fontColor8F textCenter" v-if="indexPubList[3]">{{indexPubList[3].indexDec}}</div>
				</div>
			</div>
		</div>
		<!--  多种方式，帮您闲置买卖 -->
		<div class="Monetization">
			<div class="textCenter f28 pt40">
				多种方式 帮您闲置买卖
			</div>
			<div class="line"></div>
			<div class="listMone pt40">
				<div v-for="item in listMt" class="listMt" :key="item.index">
					<div class="imgRed"><img :src="item.imgRed" /></div>
					<div class="imgBlack"><img :src="item.imgBlack" /></div>
					<div class="title f16">{{ item.title }}</div>
					<div class="line"></div>
					<div class="f12 fontColor66 text">{{ item.textOne }}<br />{{item.text}}</div>
				</div>
			</div>
		</div>

		<!--  精品二手靓 好货安心购-->
		<div class="textCenter f28 pt40">精品二手靓 好货安心购</div>
		<div class="line"></div>
		<div class="recovery pt40">
			<div class="listRe" v-for="item in listRe" :key="item.index">
				<div class="listReNav" style="cursor: pointer;" @click="showPopup">
					<img style="width: 100%;" :src="item.goodsUrl" />
				</div>
				<div class="listComWares">
					<div class="listCom" @click="showPopup" style="cursor: pointer;" v-for="itemCom in item.goodsChild"
						:key="itemCom.index">
						<div class="left">
							<img style="width: 100%;height:initial;" :src="itemCom.goodUrl">
						</div>
						<div class="right">
							<div class="title f12">{{itemCom.goodName}}</div>
							<div class="money f14">¥ {{itemCom.price}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 留言板列表滚动开始 -->
		<div class="messageBoard pt40">
			<div class="left"></div>
			<div class="right">
				<div class="slide-wrapper" @mouseenter="onMouseenter" @mouseleave="onMouseleave">
					<ul class="slide-container" ref="uls">
						<li class="slide-item" v-for="item in liData" :key="item.index" ref="lis">
							<div class="photoO" v-if="item.sort % 2 ===0 ">
								<img class="photo photo001" :src="item.headUrl">
								<div class="text">{{item.commentName}}</div>
							</div>
							<div class="photoT" v-else>
								<div class="text f13">{{item.commentName}}</div>
								<img class="photo" :src="item.headUrl">
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>

		<!-- 弹窗 -->
		<Popup :visible="popupVisible" @close="closePopup" />
	</div>
</template>
<script>
	import Popup from "@/components/popup.vue";
	export default {
		components: {
			Popup
		},
		data() {
			return {
				popupVisible: false,
				popupContent: '这是一个弹窗',
				indexPubList: [],
				listMt: [{
						title: "平台回收",
						text: "结合市场  精准估价 ",
						textOne: "平台直采  上门回收",
						imgBlack: require("../../static/shop/pthsBlack.png"),
						imgRed: require("../../static/shop/pthsRed.png")
					},
					{
						title: "闲置帮卖",
						text: "托付寄卖  专业服务 ",
						textOne: "优质快捷  处理闲置",
						imgBlack: require("../../static/shop/xzbmBlack.png"),
						imgRed: require("../../static/shop/xzbmRed.png")
					},
					{
						title: "物品寄存",
						text: "资深专家  妥善封存 ",
						textOne: "短期周转  安全可靠",
						imgBlack: require("../../static/shop/wpjcBlack.png"),
						imgRed: require("../../static/shop/wpjcRed.png")
					}
				],
				listRe: [],
				// 留言板列表滚动开始
				timer: null,
				index: 0,
				liData: [],
			};
		},
		async mounted() {
			await this.getIndexContent();
			this.listRoll();
		},
		// 列表循环滚动开始
		destroyed() {
			clearInterval(this.timer);
		},
		// 列表循环滚动结束
		methods: {
			async getIndexContent() {
				let res = await this.util.request({
					url: `/sy/website/getIndexContent/0`,
					method: 'GET',
					data: {}
				})
				if (res.status === 200) {
					this.indexPubList = res.data.indexPubList
					this.liData = res.data.commentIndexList
					this.listRe = res.data.goodsIndexList
				} else {
					console.log(res.statusText)
				}
			},

			showPopup() {
				this.popupVisible = true;
			},
			closePopup() {
				this.popupVisible = false;
			},
			// 列表循环滚动开始
			listRoll() {
				let ulDom = this.$refs.uls;
				let liDoms = this.$refs.lis;
				// li移动的最大值, 元素li的高度
				let maxL = liDoms[0].offsetHeight;
				// 列表滚动方法
				let move = () => {
					this.index++;
					if (this.index >= maxL) {
						this.index = 0;
						let tempData = [...this.liData]; // 拷贝数据源
						let tempLiArr = tempData.splice(0, 1); // 当第一个li完全移出列表时截取出第一条数据
						tempData.push(...tempLiArr); // 将被截取出的第一条li数据追加到数组最后
						this.liData = tempData; // 重新给数据源赋值
					}
					ulDom.style.top = "-" + this.index + "px"; // 每次上移的高度
				};
				clearInterval(this.timer);
				this.timer = setInterval(move, 80);
			},
			onMouseenter() {
				clearInterval(this.timer);
			},
			onMouseleave() {
				this.listRoll();
			},
			// 判断是否是手机端，如果是，返回true
			isMobile() {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				);
				return flag;
			},
		},
	}
</script>



<style lang="less" scoped>
	// 底部公共部分
	.el-carousel__item h3 {
		color: #475669;
		font-size: 18px;
		opacity: 0.75;
		line-height: 300px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	}

	.line {
		width: 35px;
		height: 2.5px;
		background: #FF354A;
		margin: auto;
		margin-top: 15px;
	}

	.leaveUnused {
		width: 55%;
		margin: auto;
		font-size: 24rpx;

		.listLuCon {
			display: flex;
			justify-content: space-around;
			width: 100%;
			margin: auto;

			.listLu {
				display: flex;
				flex-direction: column;
				align-items: center;
				width: 18%;
				padding: 30px 15px;

				.title {
					background: #fbd6d9;
					width: 3.5rem;
					height: 3.5rem;
					border-radius: 4rem;
					text-align: center;
					display: flex;
					justify-content: center;
					align-items: center;
					color: #fff;
					padding: 1%;

					.messageImg {
						display: block;
						width: 1.8rem;
						height: 1.8rem;
					}

					.messageImgActive {
						display: none;
						width: 1.8rem;
						height: 1.8rem;
					}
				}
			}
		}

		.listLu:nth-child(2) {
			background-color: #fff;
			box-shadow: 0 0 10px #d3010c1b;

			.messageImg {
				display: none !important;
			}

			.messageImgActive {
				display: block !important;
			}

			.title {
				background: #DA2020;
			}
		}

		.listLu:hover {
			background-color: #fff;
			box-shadow: 0 0 10px #d3010c1b;

			.messageImg {
				display: block;
			}

			.messageImgActive {
				display: none;
			}

			.title {
				background: #DA2020;
			}
		}

		.listLuCon:hover .listLu {
			box-shadow: none;

			.messageImg {
				width: 1.8rem;
				display: block;
			}

			.messageImgActive {
				display: none;
				width: 1.8rem;
				height: 1.8rem;
			}

			.title {
				background: #fbd6d9;
			}
		}

		.listLu:hover {
			background-color: #fff !important;
			box-shadow: 0 0 10px #d3010c1b !important;

			.messageImg {
				display: none !important;
				width: 1.8rem;
				height: 1.8rem;
			}

			.messageImgActive {
				display: block !important;
				width: 1.8rem;
				height: 1.8rem;
			}

			.title {
				background: #DA2020 !important;
			}
		}
	}

	/* 闲置买卖 */
	.Monetization {
		width: 55%;
		margin: auto;

		.listMone {
			display: flex;
			justify-content: space-around;
			align-items: center;

			.text {
				display: none;
				word-wrap: break-word;
			}

			.listMt {
				width: 13rem;
				height: 10rem;
				background-color: #F4F6F7;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;

				.imgRed {
					display: none;

					img {
						width: 50px;
					}

					padding: 10px;
				}

				.imgBlack {
					img {
						width: 50px;
					}

					padding: 10px;
				}

				.line {
					width: 90%;
					height: 1px;
					background: #FF2E3B;
					margin: 10px 0;
					display: none;
				}
			}
		}

		.listMt:first-child {
			background-color: rgba(255, 55, 78, 0.12);

			.imgBlack {
				display: none;
			}

			.imgRed {
				display: block;

				img {
					width: 25px;
				}
			}

			.line {
				display: block;
			}

			.text {
				display: block;
			}
		}

		.listMt:hover {
			background-color: rgba(255, 55, 78, 0.12);

			.imgBlack {
				display: none;
			}

			.imgRed {
				display: none;
			}

			.line {
				display: none;
			}

			.text {
				display: none;
			}
		}

		.listMone:hover .listMt {
			background-color: #F4F6F7;

			.imgBlack {
				display: block;
			}

			.imgRed {
				display: none;
			}

			.line {
				display: none;
			}

			.text {
				display: none;
			}
		}

		.listMt:hover {
			background-color: rgba(255, 55, 78, 0.12) !important;

			.imgBlack {
				display: none !important;
			}

			.imgRed {
				display: block !important;

				img {
					width: 25px !important;
				}
			}

			.line {
				display: block !important;
			}

			.text {
				display: block !important;
			}
		}

	}

	/* 精品二手靓 好货安心购 */
	.recovery {
		display: flex;
		width: 55%;
		margin: auto;
		justify-content: space-between;

		.listRe {
			display: flex;
			flex-direction: column;
			width: 49%;

			.listReNav {
				width: 100%;
				background-size: 100%;
				overflow: hidden;
				position: relative;

				.showPopup {
					position: absolute;
					right: 0;
					width: 100px;
					height: 120px;
					top: 0;
				}

			}

			.listComWares {
				padding: 0 2%;
				border: solid 1px #C2E4FC;
				border-top: none;

				.listCom {
					display: flex;
					padding: 10px 0;
					border-bottom: solid 1px #efefef;

					.left {
						width: 55px;
						height: 55px;
						overflow: hidden;
						border-radius: 8px;
						border: solid 1px #efefef;
					}

					.right {
						flex: 1;
						position: relative;
						margin-left: 2%;

						.title {
							padding-top: 5px;
						}

						.money {
							color: #f00;
							position: absolute;
							right: 0;
							bottom: 0;
							font-weight: bold;
							letter-spacing: 1px;
						}
					}
				}
			}

		}

	}

	/* 留言滚动 */

	.messageBoard {
		width: 96%;
		height: 300px;
		margin: auto;
		background-image: url("../../static/shop/lyb.png");
		background-size: 100% 100%;
		display: flex;
		align-items: center;
		margin-top: 2.5rem;

		.el-table--scrollable-y .el-table__body-wrapper {
			overflow-y: clip;
		}

		.left {
			width: 43%;
		}

		.right {

			.photoO,
			.photoT {
				display: flex;

				.text {
					flex: 1;
					width: 100%;
					background-color: #fff;
					border-radius: 10px;
					padding: 0 10px;
					text-overflow: ellipsis;
				}
			}

			.photo {
				margin-left: 10px;
				width: 45px;
				height: 45px;
				border-radius: 10px;
				overflow: hidden;
			}

			.photo001 {
				margin-right: 10px;
			}
		}

		.slide-wrapper {
			width: 100%;
			height: 300px;
			overflow: hidden;
		}

		.slide-wrapper .slide-container {
			position: relative;
			top: 0;
			left: 0;
			width: 100%;
		}

		.slide-container .slide-item {
			display: flex;
			align-items: center;
			width: 100%;
			height: 45px;
			line-height: 45px;
			margin: 30px;
			cursor: pointer;
			box-sizing: border-box;
		}
	}
</style>


// WEBPACK FOOTER //
// src/view/homePage.vue